<template>
  <el-dialog
    :close-on-click-modal="false"
    title="充值油费"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  rechargeOilCost,
} from 'api/getPay';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '充值金额',
            value: 'rechargeAmount',
            type: 'input',
            placeholder: '请输入充值金额',
          },
          {
            label: '分配油来源',
            value: 'oilAccountType',
            type: 'select',
            placeholder: '请选择分配油来源',
            options: [
              {
                label: '本车队定点油',
                value: '1',
              },
              {
                label: '找油-无发票',
                value: '2',
              },
              {
                label: '找油-有发票',
                value: '3',
              },
            ],
          },
        ],
        rules: { // 表单验证规则
          rechargeAmount: [ // 充值金额
            { required: true, message: '请输入充值金额', trigger: 'blur' },
          ],
          oilAccountType: [ // 分配油来源
            { required: true, message: '请选择分配油来源', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm.reset();
        this.originData = item;
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await rechargeOilCost({
        userId: this.originData.userId,
        userType: this.originData.userType,
        rechargeAmount: form.rechargeAmount,
        oilAccountType: form.oilAccountType,
        oilRechargeType: form.oilAccountType,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
